module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mx-auto elevation-20 pb-0 mb-0",
    staticStyle: {
      "min-height": "800px"
    }
  }, [(_vm.navDrawerIsVisible) ? _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "width": 450
    },
    model: {
      value: (_vm.showNavDrawer),
      callback: function($$v) {
        _vm.showNavDrawer = $$v
      },
      expression: "showNavDrawer"
    }
  }, [(_vm.appPlatform === 'ios') ? _c('v-system-bar', {
    staticClass: "header-toolbar",
    class: _vm.themeColor,
    attrs: {
      "status": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('home-detail', {
    attrs: {
      "homepage": _vm.schedule,
      "appointment": _vm.appointment,
      "loading": _vm.loading
    },
    on: {
      "close": function($event) {
        _vm.showNavDrawer = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "indeterminate": "",
      "height": "3"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card', {
    directives: [{
      name: "touch",
      rawName: "v-touch",
      value: ({
        left: function () {
          _vm.$emit('next')
        },
        right: function () {
          _vm.$emit('previous')
        }
      }),
      expression: "{left: () => { $emit('next') }, right: () => { $emit('previous') }}"
    }],
    attrs: {
      "dark": "",
      "flat": ""
    }
  }, [(!_vm.showDatepicker) ? _c('v-img', {
    attrs: {
      "src": _vm.backgroundImg,
      "height": "180px",
      "gradient": "to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"
    }
  }, [_c('v-layout', [_c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "fab": "",
      "small": "",
      "absolute": "",
      "top": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDatepicker = true
      }
    }
  }, [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('h3', {
    staticClass: "title font-weight-light mt-3 ml-3 grow"
  }, [_vm._v("\n            " + _vm._s(_vm.greeting) + " " + _vm._s(this.me.first_name) + "\n          ")])]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('strong', {
    staticClass: "display-4 font-weight-regular mr-4 ml-5",
    on: {
      "click": function($event) {
        _vm.showDatepicker = true
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.dateformat(_vm.date, 'D')) + "\n        ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "left": "0px",
      "top": "80px"
    },
    attrs: {
      "icon": "",
      "absolute": "",
      "left": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('previous:week')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "top": "80px"
    },
    attrs: {
      "icon": "",
      "absolute": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('next:week')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("chevron_right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "headline font-weight-light"
  }, [_vm._v("\n            " + _vm._s(_vm.dateformat(_vm.date, 'ddd')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "text-uppercase font-weight-light"
  }, [_vm._v(_vm._s(_vm.dateformat(_vm.date, 'MMMM YYYY')))]), _vm._v(" "), _c('div', [_vm._v(" ")])], 1)], 1)], 1) : _c('v-img', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "fab": "",
      "small": "",
      "absolute": "",
      "top": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDatepicker = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-date-picker', {
    staticClass: "elevation-0 pt-4 mt-4",
    attrs: {
      "dark": "",
      "flat": "",
      "full-width": "",
      "no-title": ""
    },
    model: {
      value: (_vm.localDate),
      callback: function($$v) {
        _vm.localDate = $$v
      },
      expression: "localDate"
    }
  }), _vm._v(" "), (!_vm.isToday) ? _c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "outline": ""
    },
    on: {
      "click": _vm.settoday
    }
  }, [_vm._v("Today")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/calendar",
      "block": "",
      "small": "",
      "outlined": "",
      "outline": ""
    }
  }, [_vm._v("Go to calendar")])], 1)], 1), _vm._v(" "), _c('v-slider', {
    staticClass: "mx-0 px-3 mt-0 grey lighten-5",
    attrs: {
      "ticks": "",
      "max": 6,
      "tick-labels": _vm.dow
    },
    on: {
      "change": _vm.dowChanged
    },
    model: {
      value: (_vm.debouncedDay),
      callback: function($$v) {
        _vm.debouncedDay = $$v
      },
      expression: "debouncedDay"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "touch",
      rawName: "v-touch",
      value: ({
        left: function () {
          _vm.$emit('next')
        },
        right: function () {
          _vm.$emit('previous')
        }
      }),
      expression: "{ left: () => { $emit('next') }, right: () => { $emit('previous') } }"
    }],
    staticClass: "pa-0"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.firstload && _vm.loading) ? _c('v-card-text', {
    staticClass: "text-xs-center my-5"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "width": "2",
      "size": "70"
    }
  })], 1) : _c('v-timeline', {
    staticClass: "ml-0",
    attrs: {
      "align-top": "",
      "dense": ""
    }
  }, [_c('v-timeline-item', {
    staticClass: "mt-3 pr-2"
  }, [_vm._v("\n          " + _vm._s(_vm.welcomeNote) + "\n        ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline pr-1 my-0 pl-5 bold--text grey lighten-4"
  }, [_vm._v("\n          Schedule\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "color": "primary"
    },
    on: {
      "click": _vm.newAppointmentClicked
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("event")]), _vm._v(" New")], 1)], 1), _vm._v(" "), _vm._l((_vm.appointments), function(appt) {
    return _c('v-timeline-item', {
      key: appt.id,
      class: _vm.getActiveColor(appt),
      attrs: {
        "small": "",
        "color": _vm.getColor(appt)
      }
    }, [_c('template', {
      slot: "icon"
    }, [_c('v-avatar', {
      staticClass: "pl-2",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.iconClicked(appt)
        }
      }
    })], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "pt-3": ""
      },
      on: {
        "click": function($event) {
          return _vm.itemClicked(appt)
        }
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.dateformat(appt.start_time, 'HH:mm')))]), _vm._v(" "), _c('div', [_c('small', [_vm._v("- " + _vm._s(_vm.dateformat(appt.end_time, 'HH:mm')))])])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs9": ""
      }
    }, [_c('strong', [_vm._v(_vm._s(appt.title || appt.full_name))]), _vm._v(" "), (appt.product_name) ? _c('div', {
      staticClass: "caption"
    }, [_vm._v("\n                " + _vm._s(appt.product_name) + "\n                "), (appt.address_name) ? _c('span', [_vm._v("\n                  @ " + _vm._s(appt.address_name) + "\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (appt.tags && appt.tags.length > 0) ? _vm._l((appt.tags), function(tag) {
      return _c('v-chip', {
        key: tag,
        staticClass: "v-chip--x-small",
        attrs: {
          "label": "",
          "outline": ""
        }
      }, [_vm._v("\n                  " + _vm._s(tag) + "\n                ")])
    }) : _vm._e()], 2), _vm._v(" "), (_vm.withAction) ? _c('v-flex', {
      staticClass: "text-xs-right"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1) : _vm._e()], 1)], 2)
  }), _vm._v(" "), (_vm.appointments.length < 1) ? _c('v-timeline-item', {
    attrs: {
      "fill-dot": "",
      "color": "white"
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('v-avatar', {
    staticClass: "pl-2",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.iconClicked(_vm.appointment)
      }
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pt-3"
  }, [_c('span', [_vm._v("No appointments scheduled yet.")])])], 2) : _vm._e(), _vm._v(" "), _c('v-timeline-item', {
    attrs: {
      "fill-dot": "",
      "color": "white"
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('v-avatar', {
    staticClass: "pl-2"
  }, [_vm._v(" 🎉")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pt-3"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('messages.endofday')))])])], 2)], 2)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-footer', {
    staticClass: "mb-0",
    attrs: {
      "absolute": "",
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("previous")
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showDatepicker = !_vm.showDatepicker
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.dateformat(_vm.date)) + "\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("next")
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1), _vm._v(" "), (_vm.selectedAppointment) ? _c('appointment-bottom-sheet', {
    attrs: {
      "appointment": _vm.selectedAppointment
    },
    model: {
      value: (_vm.showBottomSheet),
      callback: function($$v) {
        _vm.showBottomSheet = $$v
      },
      expression: "showBottomSheet"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04cbc24e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Schedule.vue
// module id = 1314
// module chunks = 9